module.exports = __webpack_public_path__ + "media/src/assets/img/icons/xls-cec7307e53ac24771d151806ae183144.png";